import React, { createContext, useState, useContext, useEffect } from "react";

const TimeSheetContext = createContext(null);

export const TimeSheetProvider = ({ children }) => {
  const [timeSheetUserDetails, setTimeSheetUserDetails] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const storedData = localStorage.getItem("TimeSheet");
    if (storedData) {
      setTimeSheetUserDetails(JSON.parse(storedData));
      setIsLoading(false);
    }
    // 
    const handleLoginResponse = (event) => {
      if (event?.detail) {
        localStorage.setItem("TimeSheet", JSON.stringify(event.detail));
        setTimeSheetUserDetails(event.detail);
        setIsLoading(false);
      }
      
    };
    const handleStorageChange = (event) => {
      if (event.key === "TimeSheet") {
        setTimeSheetUserDetails(event.newValue ? JSON.parse(event.newValue) : null);
      }
    };
    window.addEventListener("LOGIN_RESPONSE", handleLoginResponse);
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("LOGIN_RESPONSE", handleLoginResponse);
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  return (
    <TimeSheetContext.Provider value={{ timeSheetUserDetails, isLoading }}>
      {children}
    </TimeSheetContext.Provider>
  );
};

export const useTimeSheet = () => {
  return useContext(TimeSheetContext);
};
